<div class="add-to-wishlist" [ngClass]="{ 'in-wishlist': isInWishlist }">
  <button
    type="button"
    class="btn btn-icon"
    name="toggleWishlistBtn"
    (mouseenter)="isHovering = true"
    (mouseleave)="isHovering = false"
    (click)="toggleWishlist($event)"
  >
    <i class="far fa-heart" [ngClass]="wishlistIcon()"></i>
    <span i18n="@@ADD_TO_WISHLIST">Wishlist</span>
  </button>
</div>
